<template>
	<div class="w1400 mb50">
		<div class="logo_box flex-box">
			<router-link to="/"><img src="../../../assets/static/images/jj_logo_new.png" class="c_logo" alt="" /></router-link>
			<div class="fs18 col04 flex-box" v-if="status == 0">{{ info.aftersale_status_text }}</div>
			<!-- <div class="fs18 col04 flex-box" v-if="status == 1">退款/退货详情</div> -->
		</div>
		<div class="flex-box col90 ptb10 page_location">
			当前位置：
			<router-link class="col04" to="/Order">
				我的订单
				<span class="plr5">/</span>
			</router-link>
			<div class="now_page">售后详情</div>
		</div>
		<div class="box status_box flex-box flex-between fs24 cold2" v-if="info.type == 'refund' && info.aftersale_status >= 0">
			<div class="status_item" :class="info.aftersale_status >= 0 ? 'active' : ''">
				<i class="dot"></i>
				<div>申请退款</div>
			</div>
			<div class="status_item" :class="info.aftersale_status >= 0 ? 'active' : ''">
				<i class="dot"></i>
				<div>审核中</div>
			</div>
			<div class="status_item" :class="info.aftersale_status >= 1 ? 'active' : ''">
				<i class="dot"></i>
				<div>财务退款</div>
			</div>
			<div class="status_item" :class="info.aftersale_status >= 2 ? 'active' : ''">
				<i class="dot"></i>
				<div>已完成</div>
			</div>
		</div>
		<div class="box info_box">
			<div class="fs20 col04 fwb mb15">商品信息</div>
			<div class="title_box flex-box fs18 col04 tc">
				<div class="box1">商品</div>
				<!-- <div class="box2">规格</div> -->
				<div class="box3">单价(元)</div>
				<div class="box4">优惠</div>
				<div class="box5">数量</div>
				<div class="flex-grow-1 tc">小计(元)</div>
			</div>
			<div class="goods_box flex-box fs18">
				<div class="box1 flex-box">
					<img :src="info.goods_image" class="pic" alt="" />
					<div class="flex-grow-1 pl30">{{ info.goods_title }}</div>
				</div>
				<!-- <div class="box2 tc">3支/盒</div> -->
				<div class="box3 tc col90">{{ info.goods_price }}</div>
				<div class="box4 flex-box flex-center coleb cheap">0</div>
				<div class="box5 tc col27">× {{ info.goods_num }}</div>
				<div class="flex-grow-1 tc coleb fwb">{{ info.aftersale_fee }}</div>
			</div>
		</div>
		<div class="flex-box flex-between flex-col-stretch">
			<!-- <div class="hot_box">
                <div class="title flex-box flex-center fs20 col12 fwb mb40">热销榜</div>
                <div class="goods_box mb25 flex-box" v-for="(goods, index) in hotGoodsList" :key="index">
                    <img :src="goods.image_text" class="pic" alt="">
                    <div class="flex-grow-1">
                        <div class="coleb fs16"><span class="fs20 fwb">¥ {{ goods.min_max_price[0].min_price
                            + '~' + goods.min_max_price[0].max_price }}</span>/{{ goods.unit }}</div>
                        <div class="fs20 col27 fwb m-ellipsis mb5">{{ goods.title }}</div>
                        <div class="fs16 col96">
                            <template v-for="(params, indexs) in goods.params_text" :key="indexs">
                                <div v-if="indexs < 2">{{ params.title }}：{{ params.content }}</div>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="flex-box flex-center more fs16" @click="showMore()">查看更多</div>
            </div> -->
			<div class="detail_box">
				<div class="fs20 col04 fwb mb30">订单信息</div>
				<div class="flex-box fs18 mt35">
					<div class="flex-grow-1 col9f">原订单编号</div>
					<div class="col04 flex-box">
						<span>{{ info.order.order_sn }}</span>
						<span class="col12 cursor flex-box copy" @click="bindCopy(info.order.order_sn)">复制</span>
					</div>
				</div>
				<div class="flex-box fs18 mt35">
					<div class="flex-grow-1 col9f">售后单号</div>
					<div class="col04 flex-box">
						<span>{{ info.aftersale_sn }}</span>
						<span class="col12 cursor flex-box copy" @click="bindCopy(info.aftersale_sn)">复制</span>
					</div>
				</div>
				<div class="flex-box fs18 mt35">
					<div class="flex-grow-1 col9f">支付方式</div>
					<div class="col04" v-for="(payType, index) in info.order.pay_types_text" :key="index">{{ payType }}</div>
				</div>
				<div class="flex-box fs18 mt35">
					<div class="flex-grow-1 col9f">订单状态</div>
					<div class="col04">{{ info.order.status_text }}</div>
				</div>
				<div class="flex-box fs18 mt35">
					<div class="flex-grow-1 col9f">创建时间</div>
					<div class="col04">{{ info.order.createtime_text }}</div>
				</div>
				<div class="flex-box fs18 mt35" v-if="info.order.status_code == 'noget'">
					<div class="flex-grow-1 col9f">发货时间</div>
					<div class="col04">{{ formatDate(info.order.ext.send_time) }}</div>
				</div>
				<div class="flex-box fs18 mt35" v-if="info.order.status_code == 'completed'">
					<div class="flex-grow-1 col9f">收货时间</div>
					<div class="col04">{{ formatDate(info.order.ext.confirm_time) }}</div>
				</div>
			</div>
			<div class="detail_box">
				<div class="fs20 col04 fwb mb30">退款信息</div>

				<div class="flex-box fs18 mt35">
					<div class="flex-grow-1 col9f">实退金额</div>
					<div class="coleb fwb">¥ {{ info.refund_fee }}</div>
				</div>
				<div class="flex-box fs18 mt35">
					<div class="flex-grow-1 col9f">应退金额</div>
					<div class="coleb fwb">¥ {{ info.aftersale_fee }}</div>
				</div>
				<div class="flex-box fs18 mt35">
					<div class="flex-grow-1 col9f">退款原因</div>
					<div class="col04">{{ info.reason }}</div>
				</div>
				<div class="flex-box fs18 mt35">
					<div class="flex-grow-1 col9f">申请时间</div>
					<div class="col04">{{ formatDate(info.createtime) }}</div>
				</div>
				<div class="flex-box flex-col-start fs18 mt35">
					<div class="col9f">申请说明</div>
					<div class="flex-grow-1">
						<div class="col04 tr mb10">{{ info.content }}</div>
						<div class="flex-box flex-end flex-wrap">
							<img v-for="(img, index) in info.images" :key="index" :src="img" class="pics" alt="" />
						</div>
					</div>
				</div>
				<!-- <div class="flex-box flex-end btn_box fs20 mt35">
                    <div class="btn1 mr30">客服介入</div>
                    <div class="btn1 mr30">修改申请</div>
                    <div class="btn2" >撤销申请</div>
                </div> -->
			</div>
		</div>
		<template v-if="info.aftersale_status == 1 && info.freight_status == 1">
			<div class="box type_box mt15">
				<div class="fs20 col04 fwb mb35">退货方式</div>
				<div class="flex-box btn_box flex-between mb25">
					<div class="cursor btn fs20 active" v-if="info.refund_type == 'home'">上门取件</div>
					<div class="cursor btn fs20 active" v-if="info.refund_type == 'express'">寄送快递</div>
				</div>
				<div class="flex-box col04 fs18 mt60" v-if="info.refund_type == 'home'">
					<div>联系人：{{ info.company ? info.company.company : "" }}</div>
					<div class="flex-box phone">
						<span>联系电话：{{ info.company ? info.company.mobile : "" }}</span>
						<span class="col12 copy flex-box" @click="bindCopy(info.company.mobile)">复制</span>
					</div>
				</div>
				<div v-if="info.refund_type == 'express'">
					<div class="code_num flex-box">
						<input type="text" class="flex-grow-1 fs20" placeholder="请输入快递公司" v-model="freight_company" />
						<div class="scan cursor"></div>
					</div>
					<div class="code_num flex-box">
						<input type="text" class="flex-grow-1 fs20" placeholder="请输入快递单号" v-model="freight_express_no" />
						<div class="scan cursor"></div>
					</div>
				</div>
			</div>
			<div class="box send_box mt20" v-if="info.refund_type == 'express'">
				<div class="title_box flex-box fs20 col27 fwb">
					<div class="flex-grow-1">收件人信息</div>
					<div class="fs18 col12 cursor">复制</div>
				</div>
				<div class="detail_box">
					<!-- <div class="flex-box shop fs20 col12 fwb mb15">***医疗美容机构</div> -->
					<div class="flex-box fs20 col27 fwb mb10">
						<div>{{ info.shop_address.address }}</div>
						<!-- <div class="default fs14 colf">默认</div> -->
					</div>
					<div class="fs18 fs27">{{ info.shop_address.contact ? info.shop_address.contact : "" }} {{ info.shop_address.contact_mobile }}</div>
				</div>
			</div>
			<div class="box send_box mt20" v-if="info.refund_type == 'home'">
				<div class="title_box flex-box fs20 col27 fwb">
					<div class="flex-grow-1">寄件人信息</div>
					<div class="fs18 col12 cursor">复制</div>
				</div>
				<div class="detail_box">
					<!-- <div class="flex-box shop fs20 col12 fwb mb15">***医疗美容机构</div> -->
					<div class="flex-box fs20 col27 fwb mb10">
						<div>{{ info.order.address.province_name + "-" + info.order.address.city_name + "-" + info.order.address.district_name }}{{ info.order.address.address }}</div>
						<!-- <div class="default fs14 colf">默认</div> -->
					</div>
					<div class="fs18 fs27">{{ info.order.address.consignee }} {{ info.order.address.mobile }}</div>
				</div>
			</div>
			<div class="box code_box mt15" v-if="info.refund_type == 'home'">
				<div class="fs20 col04 fwb mb30">取件码</div>
				<div class="flex-box">
					<input type="number" class="input" v-model="home_code" maxlength="6" />
					<!-- <div class="btn fs20 colf flex-box flex-center cursor">确认</div> -->
					<div class="btn fs20 colf flex-box flex-center cursor can" @click="onHomeSave()">确认</div>
				</div>
			</div>
		</template>
		<div class="flex-box flex-end mt45">
			<div class="foot_btn fs20 fwb" @click="customerService()">客服介入</div>
			<div class="foot_btn fs20 fwb" v-if="info.aftersale_status == 0 || info.aftersale_status == 1" @click="onApply(info.id)">撤销申请</div>
			<div class="foot_btn sure fs20 fwb" v-if="info.aftersale_status == 1 && info.freight_status == 1 && info.refund_type == 'express'" @click="onSave()">确认退货</div>
		</div>
	</div>
</template>

<script>
	import { useHead } from "@unhead/vue";
	import { onMounted } from "vue";
	import moment from "moment";
	export default {
		setup() {
			onMounted(() => {
				useHead({
					title: "售后详情-小狮优选",
					meta: [
						{ name: "description", content: "This is my page description" },
						{ property: "og:title", content: "My Page Title" },
						{ property: "og:description", content: "This is my page description" },
						{ property: "og:url", content: "https://example.com/my-page" },
						{ property: "og:image", content: "https://example.com/my-image.jpg" },
					],
					link: [{ rel: "canonical", href: "https://example.com/my-page" }],
				});
			});
		},
		data() {
			return {
				status: 0, //0退款 1退款退货
				info: {
					order: {
						order_sn: "",
						status_text: "",
						pay_types_text: [],
					},
				},
				hotGoodsList: [],
				showReason: false,

				freight_company: "",
				freight_express_no: "",
				home_code: "",
			};
		},
		created() {
			this.aftersaleId = this.$route.query.id;
			this.getDetail();
			this.getHotGoodsList();
		},
		methods: {
			getDetail() {
				this.$api.AftersaleDetail({ id: this.aftersaleId }).then((ret) => {
					this.info = ret.data;
					this.info.images = ret.data.logs[ret.data.logs.length - 1].images;
				});
			},
			// 获取热门产品列表
			getHotGoodsList() {
				this.$api.GetGoods({ sort: "sales", order: "desc", list_rows: 3 }).then((res) => {
					if (res.code == 1) {
						this.hotGoodsList = res.data.data;
					}
				});
			},
			showMore() {
				this.$router.push({ path: "/FindProduct" });
			},
			//格式化日期
			formatDate(timestamp) {
				if (!timestamp) {
					return "";
				}
				return moment(timestamp * 1000).format("YYYY-MM-DD HH:mm:ss");
			},
			onApply(orderId) {
				let page = this;
				this.$confirm("确定要取消此申请吗？", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
				}).then(() => {
					page.$api.AftersaleCancel({ id: orderId }).then((ret) => {
						page.getDetail();
					});
				});
			},
			onSave() {
				let page = this;
				if (page.freight_express_no.trim() == "" || page.freight_express_no.trim() == "") {
					uni.showToast({ title: "物流参数不得为空", icon: "none" });
					return;
				}
				this.$confirm("确定要提交物流信息吗？", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
				}).then(() => {
					page.$api.AftersaleExpress({ id: page.aftersaleId, freight_express_no: page.freight_express_no, freight_company: page.freight_company }).then((ret) => {
						page.getDetail();
					});
				});
			},
			onHomeSave() {
				let page = this;
				if (page.home_code.trim() == "") {
					uni.showToast({ title: "取件码不得为空", icon: "none" });
					return;
				}
				this.$confirm("确定提交？", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
				}).then(() => {
					page.$api.AftersaleHome({ id: page.aftersaleId, home_code: page.home_code }).then((ret) => {
						page.getDetail();
					});
				});
			},
			customerService() {
				this.$router.push({ path: "/CustomerSer" });
			},

			bindCopy(textToCopy) {
				navigator.clipboard
					.writeText(textToCopy)
					.then(() => {
						this.$message({
							customClass: "custom-message",
							message: "内容已复制",
							type: "success",
						});
						// this.$alert('内容已复制');
					})
					.catch((error) => {
						this.$alert("复制失败");
						console.error("复制失败：", error);
					});
			},
		},
	};
</script>

<style lang="less" scoped>
	.logo_box {
		height: 150px;

		.c_logo {
			width: 170px;
			display: block;
			margin: 0 60px 0 16px;
		}

		.fs18::before {
			display: block;
			content: "";
			width: 2px;
			height: 100px;
			background: rgba(98, 134, 171, 0.4);
			margin-right: 60px;
		}
	}

	.page_location {
		margin: 26px 0 24px;
		padding-bottom: 0;
	}

	.box {
		background: #fff;
	}

	.status_box {
		padding: 80px 160px;
		margin-bottom: 15px;

		.status_item {
			width: 160px;
			text-align: center;

			.dot {
				width: 25px;
				height: 25px;
				border: 3px solid #d2d2d2;
				border-radius: 50%;
				display: block;
				margin: 0 auto 24px;
				position: relative;

				&::before {
					content: "";
					display: block;
					width: 252px;
					height: 1px;
					background: #d2d2d2;
					position: absolute;
					top: 9px;
					right: 38px;
				}
			}

			&:first-child {
				.dot::before {
					display: none;
				}
			}

			&.active {
				color: #3f7ffe;

				.dot {
					border-color: #ffcc3b;
					background: #ffcc3b;

					&::before {
						background: #ffcc3b;
					}
				}
			}
		}
	}

	.info_box {
		padding: 40px;
		margin-bottom: 15px;

		.title_box {
			width: 1312px;
			height: 50px;
			background: #fafcff;
		}

		.goods_box {
			height: 192px;
			border-bottom: 1px solid rgba(98, 134, 171, 0.4);
		}

		.box1 {
			width: 473px;

			.pic {
				width: 144px;
				height: 144px;
				background: #ffffff;
				border-radius: 8px;
				border: 1px solid rgba(98, 134, 171, 0.2);
				margin-left: 44px;
			}

			span {
				width: 43px;
				height: 20px;
				background: linear-gradient(153deg, #ff4d4d 0%, #ff652d 100%);
				border-radius: 5px;
				display: inline-block;
				line-height: 20px;
				text-align: center;
				margin-right: 10px;
			}
		}

		.box2 {
			width: 164px;
		}

		.box3 {
			width: 148px;
		}

		.box4 {
			width: 200px;

			&.cheap::before {
				display: block;
				content: "";
				width: 11px;
				height: 20px;
				background: url("../../../assets/static/icon/c_cheap.png") no-repeat center;
				background-size: 100%;
				margin-right: 7px;
			}
		}

		.box5 {
			width: 200px;
		}
	}

	.hot_box {
		margin: 60px 51px 0 37px;
		width: 480px;

		.title::before {
			content: "";
			display: block;
			width: 23.5px;
			height: 36.5px;
			background: url("../../../assets/static/icon/c_hot.png") no-repeat center;
			background-size: 100%;
			margin-right: 12px;
		}

		.goods_box {
			width: 480px;
			height: 186px;
			background: #f5f8fe;
			border-radius: 8px;

			.pic {
				width: 154px;
				height: 154px;
				background: #ffffff;
				border-radius: 8px;
				margin-right: 50px;
				object-fit: cover;
				margin-left: 42px;
			}
		}

		.more {
			color: #969696;
			cursor: pointer;

			&::after {
				display: block;
				content: "";
				width: 14.5px;
				height: 14.5px;
				background: url("../../../assets/static/icon/c_hot_more.png") no-repeat center;
				background-size: 100%;
				margin-left: 14px;
			}
		}
	}

	.copy::before {
		content: "";
		display: block;
		margin: 0 20px 0 15px;
		width: 1px;
		height: 13px;
		background: #272727;
	}

	.detail_box {
		width: calc((100% - 15px) / 2);
		background: #ffffff;
		padding: 46px 44px 44px;

		.pics {
			width: 102px;
			height: 102px;
			border-radius: 10px;
			margin-left: 20px;
		}

		.btn1 {
			width: 228px;
			height: 66px;
			border-radius: 6px;
			border: 2px solid #e6e6e6;
			line-height: 62px;
			text-align: center;
			color: #434343;
		}

		.btn2 {
			width: 228px;
			height: 66px;
			border-radius: 6px;
			border: 2px solid #1275ff;
			background: #1275ff;
			line-height: 62px;
			text-align: center;
			color: #fff;
		}
	}

	.type_box {
		padding: 42px 44px 44px;

		.mt60 {
			margin-top: 60px;
		}

		.btn_box {
			.btn {
				width: 642px;
				height: 64px;
				border-radius: 8px;
				border: 2px solid #e6e6e6;
				line-height: 60px;
				text-align: center;

				&.active {
					border-color: #1275ff;
					background-color: #1275ff;
					color: #fff;
				}
			}
		}

		.phone {
			margin-left: 350px;
		}

		.code_num {
			width: 756px;
			height: 68px;
			background: #f2f7ff;
			border-radius: 8px;
			padding-left: 26px;
			padding-right: 18px;

			input {
				height: 68px;
			}

			.scan {
				width: 48.5px;
				height: 48.5px;
				background: url("../../../assets/static/icon/c_scan.png") no-repeat center;
				background-size: 100%;
				position: relative;

				&::before {
					content: "";
					display: block;
					width: 2px;
					height: 30px;
					background: #a5a5a5;
					position: absolute;
					top: 9.25px;
					left: -8px;
				}
			}
		}
	}

	.send_box {
		.title_box {
			height: 93px;
			border-bottom: 1px solid rgba(98, 134, 171, 0.4);
			padding-left: 68px;
			padding-right: 44px;

			&::before {
				content: "";
				display: block;
				width: 17px;
				height: 20px;
				margin-right: 14px;
				background: url("../../../assets/static/icon/c_send.png") no-repeat center;
				background-size: 100%;
			}
		}

		.detail_box {
			padding: 22px 100px 44px;

			.shop {
				position: relative;

				&::before {
					content: "";
					display: block;
					width: 16px;
					height: 14px;
					background: url("../../../assets/static/icon/c_send_shop.png") no-repeat center;
					background-size: 100%;
					position: absolute;
					top: 10px;
					left: -31px;
				}
			}

			.default {
				margin-left: 14px;
				width: 43px;
				height: 20px;
				line-height: 20px;
				text-align: center;
				background: linear-gradient(117deg, #3d6cfe 0%, #4ac3fc 100%);
				border-radius: 4px;
				border: 1px solid;
				border-image: linear-gradient(196deg, rgba(255, 255, 255, 1), rgba(18, 117, 255, 0)) 1 1;
			}
		}
	}

	.code_box {
		padding: 42px 44px 35px;

		.input {
			width: 583px;
			height: 68px;
			background: #f2f7ff;
			border-radius: 8px;
			padding: 0 26px;
		}

		.btn {
			width: 173px;
			height: 68px;
			background: #abceff;
			border-radius: 8px;
			margin-left: 25px;

			&.can {
				background: #1275ff;
			}
		}
	}

	.foot_btn {
		width: 228px;
		height: 66px;
		border-radius: 6px;
		border: 2px solid #e6e6e6;
		color: #434343;
		line-height: 62px;
		text-align: center;
		margin-left: 30px;
		cursor: pointer;

		&.sure {
			border-color: #abceff;
			background-color: #abceff;
			color: #fff;
		}

		&.sure.can {
			border-color: #1275ff;
			background-color: #1275ff;
		}
	}

	.log_box {
		padding: 41px 642px 50px 44px;

		.log_list {
			margin-top: 27px;
			margin-left: 47px;

			.item {
				padding-bottom: 33px;
				border-bottom: 1px solid #e7e7e7;
				position: relative;
				margin-left: 105px;
				line-height: 1;
				color: #bcbcbc;
				padding-top: 38px;

				i {
					width: 12px;
					height: 12px;
					background: #d8d8d8;
					border-radius: 50%;
					position: absolute;
					left: -110px;
					top: 38px;
				}

				&::before {
					content: "";
					display: block;
					width: 2px;
					height: 100%;
					background: #d8d8d8;
					position: absolute;
					left: -105px;
					top: 48px;
				}

				&.active .fs18 {
					color: #272727;
				}

				&.active i,
				&.active::before {
					background: #ffcc3b;
				}

				&.active::after {
					content: "";
					display: block;
					width: 22px;
					height: 22px;
					background: #ffcc3b;
					opacity: 0.4;
					border-radius: 50%;
					position: absolute;
					left: -115px;
					top: 33px;
				}

				&:last-child::before {
					display: none;
				}
			}
		}
	}
</style>
